import styled from 'styled-components';

export const ScenesContainer = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const SceneStage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 940 / 570;
  flex-shrink: 0;
  min-height: 0;
`;

export const SceneMotionWrap = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  animation: sceneFadeIn 0.45s cubic-bezier(0.22, 1, 0.36, 1);

  @keyframes sceneFadeIn {
    from {
      opacity: 0;
      transform: translateY(16px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

export const SceneProgress = styled.div`
  margin-top: 32px;
`;

export const SceneProgressRow = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 auto;
`;

export const SceneProgressButton = styled.button`
  flex: 1;
  border: none;
  background: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;
`;

export const SceneProgressTrack = styled.div`
  height: 3px;
  width: 100%;
  overflow: hidden;
  border-radius: 9999px;
  background: rgba(49, 49, 49, 0.1);
  margin: 0 0 5px;
`;

export const SceneProgressFill = styled.div`
  height: 100%;
  border-radius: 9999px;
  background-image: var(--onboarding-brand-gradient);
  transition: width 0.05s linear;
`;

export const SceneProgressLabel = styled.p`
  margin-top: 8px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: ${({ $active }) => ($active ? 'var(--text-color-50)' : 'var(--text-color)')};
`;

export const SceneShell = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    0 16px 40px -20px rgba(50, 40, 95, 0.18);
`;

export const SceneHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  flex-shrink: 0;
`;

export const SceneIconBadge = styled.span`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-image: var(--onboarding-brand-gradient);
  box-shadow: 0 2px 8px rgba(37, 128, 243, 0.2);

  svg {
    width: 16px;
    height: 16px;
    color: var(--white);
  }
`;

export const SceneTitle = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--text-color);
`;

export const SceneSubtitle = styled.p`
  margin: 2px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color-50);
`;

export const SceneCard = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.4);
  padding: 12px;
  margin-bottom: 12px;
  flex-shrink: 0;
`;

export const SceneRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
`;

export const SceneSummary = styled.div`
  margin-top: auto;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.45);
  padding: 12px;
  min-height: 0;
  flex-shrink: 1;

  p {
    margin: 0;
    font-size: 11px;
    line-height: 1.45;
    color: var(--text-color);
  }
`;

export const SceneAnalysisContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const SceneAnalysisKicker = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: var(--text-color);
`;

export const SceneAnalysisHeading = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-color-50);
`;

export const SceneAnalysisScanPanel = styled.div`
  position: relative;
  margin-top: 24px;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.7);
  padding: 20px;
  box-shadow: 0 1px 2px rgba(24, 27, 46, 0.05);
  flex-shrink: 0;
`;

export const SceneAnalysisScanRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: var(--text-color);
`;

export const SceneAnalysisPulseDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background-image: var(--onboarding-brand-gradient);
  animation: sceneAnalysisPulse 1.6s ease-in-out infinite;

  @keyframes sceneAnalysisPulse {
    0%,
    100% {
      opacity: 1;
    }

    50% {
      opacity: 0.35;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SceneAnalysisFieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 16px;
`;

export const SceneAnalysisField = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 1);
  padding: 12px;
  opacity: 0;
  transform: translateY(6px);
  animation: sceneAnalysisFieldIn 0.4s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay}ms;

  @keyframes sceneAnalysisFieldIn {
    from {
      opacity: 0;
      transform: translateY(6px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
    animation: none;
  }
`;

export const SceneAnalysisFieldLabel = styled.p`
  margin: 0;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-color);
`;

export const SceneAnalysisFieldValue = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-color-50);
`;

export const SceneAnalysisSummaryBlock = styled.div`
  margin-top: 16px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.6);
  padding: 16px;
  flex-shrink: 0;
`;

export const SceneAnalysisSummaryLabel = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-color);
`;

export const SceneAnalysisSummaryText = styled.p`
  margin: 8px 0 0;
  font-size: 13.5px;
  line-height: 1.625;
  color: rgba(49, 49, 49, 0.85);
`;

export const SceneAnalysisFoot = styled.div`
  margin-top: auto;
  padding-top: 16px;
  flex-shrink: 0;
`;

export const SceneAnalysisFootRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
`;

export const SceneAnalysisFootMuted = styled.span`
  color: var(--text-color);
`;

export const SceneAnalysisFootStrong = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--text-color-50);

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const SceneAnalysisCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const SceneAnalysisCard = styled(SceneShell)`
  width: 700px;
  height: 500px;
  flex-shrink: 0;
  padding: 20px;
`;

export const SceneAnalysisUrl = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  span:first-of-type {
    font-size: 12px;
    color: #737373;
  }

  span:last-of-type {
    font-size: 12px;
    font-weight: 500;
    color: var(--text-color-50);
  }

  svg {
    color: #737373;
  }
`;

export const SceneAnalysisBarTrack = styled.div`
  height: 8px;
  border-radius: 999px;
  background: rgba(10, 10, 10, 0.05);
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SceneAnalysisBarFill = styled.div`
  height: 100%;
  width: ${({ $width }) => $width}%;
  border-radius: 999px;
  background: linear-gradient(135deg, #b74bff 0%, #2580f3 100%);
`;

export const SceneAnalysisTags = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 12px;
`;

export const SceneAnalysisTag = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.5);
  padding: 10px 8px;
  text-align: center;

  p {
    margin: 6px 0 0;
    font-size: 11px;
    font-weight: 600;
    color: var(--text-color-50);
  }
`;

export const SceneAnalysisSummaryHead = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;

  strong {
    font-size: 11px;
    color: var(--text-color-50);
  }

  svg {
    color: #b74bff;
  }
`;

export const SceneAnalysisMainCard = styled(SceneShell)`
  width: 680px;
  height: 500px;
  flex-shrink: 0;
  padding: 28px 32px 24px;
  background: #fff;
  animation: sceneAnalysisFloat 7s ease-in-out infinite;

  @keyframes sceneAnalysisFloat {
    0%,
    100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-7px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SceneAnalysisMainHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
  flex-shrink: 0;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '22px')});
  transition:
    opacity 0.62s ease-out,
    transform 0.62s ease-out;
`;

export const SceneAnalysisLogo = styled.img`
  width: 46px;
  height: 46px;
  flex-shrink: 0;
`;

export const SceneAnalysisStep = styled.p`
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--text-color);

  span {
    color: #9b33e6;
  }
`;

export const SceneAnalysisDomain = styled.p`
  margin: 3px 0 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--text-color-50);
  line-height: 1.1;
`;

export const SceneAnalysisBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '-16px')});
  transition:
    opacity 0.5s ease-in-out,
    transform 0.5s ease-in-out;
`;

export const SceneAnalysisRow = styled.div`
  display: flex;
  gap: 22px;
  flex: 1;
  min-height: 0;
`;

export const SceneAnalysisSite = styled.div`
  flex: 0 0 232px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #dde0ea;
  background: #fff;
  box-shadow: 0 12px 26px -16px rgba(40, 32, 86, 0.45);
  position: relative;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '22px')});
  transition:
    opacity 0.62s ease-out,
    transform 0.62s ease-out;
  transition-delay: ${({ $visible }) => ($visible ? '80ms' : '0ms')};
`;

export const SceneAnalysisSiteBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 11px;
  background: #f6f7fb;
  border-bottom: 1px solid #eceef4;
`;

export const SceneAnalysisSiteDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #dde0ea;
`;

export const SceneAnalysisSiteUrl = styled.span`
  margin-left: 7px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  color: #757b9c;
  font-weight: 500;
  background: #fff;
  border: 1px solid #eceef4;
  border-radius: 999px;
  padding: 3px 11px;
`;

export const SceneAnalysisSiteBody = styled.div`
  position: relative;
  padding: 15px;
  height: 218px;
  overflow: hidden;
`;

export const SceneAnalysisSkHero = styled.div`
  height: 15px;
  width: 72%;
  border-radius: 5px;
  background-image: var(--onboarding-brand-gradient);
  opacity: 0.9;
  margin: 0 0 13px;
`;

export const SceneAnalysisSkLine = styled.div`
  height: 9px;
  border-radius: 4px;
  background: #eceef4;
  margin: 0 0 8px;
  width: ${({ $width }) => $width || '100%'};
`;

export const SceneAnalysisSkCards = styled.div`
  display: flex;
  gap: 10px;
  margin: 15px 0 0;

  span {
    flex: 1;
    height: 50px;
    border-radius: 8px;
    background: #f6f7fb;
    border: 1px solid #eceef4;
  }
`;

export const SceneAnalysisSiteGrid = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.6;
  background: linear-gradient(rgba(124, 78, 240, 0.045) 1px, transparent 1px) 0 0 / 100% 22px;
`;

export const SceneAnalysisBeam = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 50px;
  top: -50px;
  pointer-events: none;
  z-index: 3;
  background: linear-gradient(
    180deg,
    rgba(37, 128, 243, 0) 0%,
    rgba(37, 128, 243, 0.13) 46%,
    rgba(183, 75, 255, 0.18) 56%,
    rgba(183, 75, 255, 0) 100%
  );

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: linear-gradient(90deg, rgba(37, 128, 243, 0), #2580f3 30%, #b74bff 70%, rgba(183, 75, 255, 0));
    box-shadow: 0 0 14px 2px rgba(124, 78, 240, 0.55);
  }

  animation: ${({ $active }) =>
    $active ? 'sceneAnalysisScan 2.5s cubic-bezier(0.65, 0, 0.35, 1) 2 alternate forwards' : 'none'};

  @keyframes sceneAnalysisScan {
    from {
      transform: translateY(0);
    }

    to {
      transform: translateY(266px);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SceneAnalysisPing = styled.span`
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #b74bff;
  left: ${({ $left }) => $left};
  top: ${({ $top }) => $top};
  opacity: 0;
  z-index: 2;
  animation: ${({ $active, $delay }) =>
    $active ? `sceneAnalysisPing 2.5s cubic-bezier(0.65, 0, 0.35, 1) infinite ${$delay}ms` : 'none'};

  @keyframes sceneAnalysisPing {
    0%,
    10% {
      opacity: 0;
      transform: scale(0.4);
    }

    16% {
      opacity: 1;
      transform: scale(1);
    }

    38% {
      opacity: 1;
    }

    58%,
    100% {
      opacity: 0;
      box-shadow: 0 0 0 11px rgba(183, 75, 255, 0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0;
  }
`;

export const SceneAnalysisExtract = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const SceneAnalysisScanStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 13px;
  color: var(--text-color);
  font-weight: 500;
  margin-bottom: 16px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '22px')});
  transition:
    opacity 0.62s ease-out,
    transform 0.62s ease-out;
  transition-delay: ${({ $visible }) => ($visible ? '160ms' : '0ms')};
`;

export const SceneAnalysisScanDot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
  background-image: var(--onboarding-brand-gradient);
  animation: sceneAnalysisScanPulse 1.6s ease-in-out infinite;

  @keyframes sceneAnalysisScanPulse {
    0% {
      box-shadow: 0 0 0 0 rgba(124, 78, 240, 0.4);
    }

    70%,
    100% {
      box-shadow: 0 0 0 9px rgba(124, 78, 240, 0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const SceneAnalysisFields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 20px;
  margin-bottom: 16px;
`;

export const SceneAnalysisFieldItem = styled.div``;

export const SceneAnalysisFieldSlot = styled.div`
  position: relative;
  height: 22px;
`;

export const SceneAnalysisFieldPh = styled.span`
  position: absolute;
  left: 0;
  top: 5px;
  height: 11px;
  width: 62%;
  border-radius: 4px;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  background: linear-gradient(90deg, #eceef4, #f6f7fb, #eceef4);
  background-size: 200% 100%;
  animation: ${({ $hidden }) => ($hidden ? 'none' : 'sceneAnalysisShimmer 1.25s linear infinite')};
  transition: opacity 0.3s ease-out;

  @keyframes sceneAnalysisShimmer {
    0% {
      background-position: 200% 0;
    }

    100% {
      background-position: -200% 0;
    }
  }
`;

export const SceneAnalysisFieldReveal = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--text-color-50);
  letter-spacing: -0.01em;
  white-space: nowrap;
  clip-path: inset(0 ${({ $revealed }) => ($revealed ? 0 : 100)}% 0 0);
  transition: clip-path 0.5s ease-out;
`;

export const SceneAnalysisSummaryWrap = styled.div`
  flex-shrink: 0;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '22px')});
  transition:
    opacity 0.62s ease-out,
    transform 0.62s ease-out;
  transition-delay: ${({ $visible }) => ($visible ? '2700ms' : '0ms')};
`;

export const SceneAnalysisSummaryWords = styled.p`
  margin: 7px 0 0;
  font-size: 14.5px;
  line-height: 1.5;
  color: var(--text-color-50);
  font-weight: 500;
`;

export const SceneAnalysisSummaryWord = styled.span`
  display: inline-block;
  margin-right: 0.28em;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transform: translateY(${({ $active }) => ($active ? 0 : '5px')});
  transition:
    opacity 0.34s ease-out,
    transform 0.34s ease-out;
  transition-delay: ${({ $delay }) => $delay}ms;

  &:last-child {
    margin-right: 0;
  }
`;

export const SceneAnalysisMainFoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-size: 13.5px;
  margin-top: auto;
  padding-top: 12px;
  flex-shrink: 0;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '22px')});
  transition:
    opacity 0.62s ease-out,
    transform 0.62s ease-out;
  transition-delay: ${({ $visible }) => ($visible ? '4100ms' : '0ms')};
`;

export const SceneAnalysisConfidence = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--text-color-50);
`;

export const SceneAnalysisCheck = styled.span`
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #effad9;
  color: #5fb800;

  svg {
    width: 11px;
    height: 11px;
  }
`;

export const SceneCanvasStage = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  border-radius: 16px;
  background: transparent;
  isolation: isolate;
`;

export const LeadFinderStage = SceneCanvasStage;

export const SceneDesignCanvas = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 940px;
  height: 570px;
  transform: translate(-50%, -50%) scale(${({ $scale }) => $scale});
  transform-origin: center center;
`;

export const LeadFinderCanvas = SceneDesignCanvas;

export const LeadFinderGlassBase = styled.div`
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(20px) saturate(140%);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    0 16px 40px -20px rgba(50, 40, 95, 0.22);

  > * {
    position: relative;
    z-index: 1;
  }
`;

export const LeadFinderGlass = styled(LeadFinderGlassBase)`
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 0;
    border-radius: inherit;
    pointer-events: none;
    background: linear-gradient(
      122deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.18) 46%,
      rgba(255, 255, 255, 0.32) 50%,
      rgba(255, 255, 255, 0.08) 55%,
      rgba(255, 255, 255, 0) 67%
    );
  }
`;

export const LeadFinderFilterPanel = styled(LeadFinderGlassBase)`
  position: absolute;
  left: 0;
  top: 58px;
  width: 336px;
  z-index: 2;
  border-radius: 26px;
  padding: 18px 42px 10px 18px;
`;

export const LeadFinderSearchPanel = styled(LeadFinderGlass)`
  position: absolute;
  left: 310px;
  top: 84px;
  width: 630px;
  z-index: 3;
  border-radius: 28px;
  padding: 22px 22px 0;
`;

export const LeadFinderBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-color-50);

  img {
    width: 30px;
    height: 30px;
    border-radius: 9px;
    object-fit: cover;
  }
`;

export const LeadFinderFilterHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid rgba(20, 16, 52, 0.1);

  strong {
    font-size: 13px;
    color: var(--text-color-50);
  }

  span {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-color);
    background: rgba(255, 255, 255, 0.55);
    border: 1px solid rgba(20, 16, 52, 0.06);
    border-radius: 10px;
    padding: 5px 10px;
    margin-left: 6px;
  }
`;

export const LeadFinderFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 11px 2px;
  border-bottom: 1px solid rgba(20, 16, 52, 0.08);

  &:last-child {
    border-bottom: 0;
  }

  svg {
    flex: none;
    width: 18px;
    height: 18px;
    color: var(--text-color);
  }

  span {
    flex: 1;
    font-size: 13.5px;
    font-weight: 500;
    color: var(--text-color);
  }
`;

export const LeadFinderHero = styled.p`
  margin: 2px 0 15px;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--text-color-50);

  span {
    background-image: var(--onboarding-brand-gradient);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const LeadFinderSearchRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const LeadFinderSearchField = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  gap: 10px;
  min-width: 0;
  height: 50px;
  padding: 0 18px;
  overflow: hidden;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95);

  svg {
    flex: none;
    width: 17px;
    height: 17px;
    color: var(--text-color);
  }
`;

export const LeadFinderPlaceholder = styled.span`
  position: absolute;
  left: 46px;
  font-size: 15px;
  color: var(--text-color);
  pointer-events: none;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
  transition: opacity 0.2s;
`;

export const LeadFinderSearchText = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: var(--text-color-50);
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const LeadFinderCaret = styled.span`
  width: 2px;
  height: 20px;
  margin-left: -10px;
  background: #2580f3;
  border-radius: 2px;
  animation: leadFinderBlink 1.05s steps(2, jump-none) infinite;

  @keyframes leadFinderBlink {
    50% {
      opacity: 0;
    }
  }
`;

export const LeadFinderAiButton = styled.button`
  position: relative;
  z-index: 1;
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  padding: 0 20px;
  border: 0;
  border-radius: 999px;
  background-image: var(--onboarding-brand-gradient);
  color: var(--white);
  font-size: 14px;
  font-weight: 600;
  cursor: default;
  box-shadow:
    0 10px 22px -10px rgba(124, 78, 240, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.45);
  transform: scale(${({ $pressed }) => ($pressed ? 0.96 : 1)});
  transition: transform 0.2s ease;

  svg {
    width: 15px;
    height: 15px;
  }
`;

export const LeadFinderStatus = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 13px 2px 2px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--text-color);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.3s ease;

  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #8eea00;
    box-shadow: 0 0 0 2px rgba(142, 234, 0, 0.22);
  }
`;

export const LeadFinderResultsWrap = styled.div`
  margin-top: 14px;
  height: 236px;
  overflow: hidden;
  mask-image: linear-gradient(180deg, #000 78%, transparent 100%);
`;

export const LeadFinderResults = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  opacity: ${({ $fading }) => ($fading ? 0 : 1)};
  transition: opacity 0.5s ease;
`;

export const LeadFinderLeadRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  border-radius: 14px;
  background: var(--white);
  border: 1px solid rgba(20, 16, 52, 0.04);
  box-shadow: 0 8px 20px -10px rgba(40, 30, 90, 0.22);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '12px')});
  transition:
    opacity 0.42s ease,
    transform 0.42s ease;
`;

export const LeadFinderAvatar = styled.span`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex: none;
  display: grid;
  place-items: center;
  color: var(--white);
  font-size: 12.5px;
  font-weight: 600;
  background-image: var(--onboarding-brand-gradient);
`;

export const LeadFinderLeadMeta = styled.div`
  flex: 1;
  min-width: 0;

  strong {
    display: block;
    font-size: 13.5px;
    font-weight: 600;
    color: var(--text-color-50);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    font-size: 11.5px;
    color: var(--text-color);
  }
`;

export const LeadFinderMatch = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  width: 92px;
  flex: none;

  strong {
    font-size: 12px;
    font-weight: 700;
    color: #7c4ef0;
  }
`;

export const LeadFinderMatchBar = styled.div`
  width: 84px;
  height: 5px;
  border-radius: 999px;
  background: rgba(24, 16, 52, 0.1);
  overflow: hidden;

  i {
    display: block;
    height: 100%;
    width: ${({ $width }) => $width}%;
    border-radius: 999px;
    background: linear-gradient(90deg, #2580f3, #b74bff);
    transition: width 0.75s ease 0.12s;
  }
`;

export const AiSequenceStage = SceneCanvasStage;

export const AiSequenceCanvas = styled(SceneDesignCanvas)`
  height: 470px;
`;

export const AiSequenceWires = styled.svg`
  position: absolute;
  inset: 0;
  width: 940px;
  height: 470px;
  z-index: 1;
  pointer-events: none;
`;

export const AiSequenceWire = styled.path`
  fill: none;
  stroke: url(#aiSeqWireGrad);
  stroke-width: 2;
  stroke-linecap: round;
  opacity: ${({ $drawn }) => ($drawn ? 0.8 : 0)};
  transition: opacity 0.35s ease;
`;

export const AiSequenceChat = styled.div`
  position: absolute;
  left: 24px;
  top: 34px;
  width: 332px;
  height: 402px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(20px) saturate(140%);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    0 16px 40px -20px rgba(50, 40, 95, 0.22);
  opacity: ${({ $fading }) => ($fading ? 0 : 1)};
  transition: opacity 0.5s ease;
`;

export const AiSequenceChatHead = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  flex: none;

  img {
    width: 36px;
    height: 36px;
    border-radius: 11px;
    object-fit: cover;
  }

  strong {
    display: block;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-color-50);
  }

  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 11.5px;
    color: var(--text-color);

    i {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #8eea00;
      box-shadow: 0 0 0 3px rgba(142, 234, 0, 0.22);
    }
  }

  em {
    margin-left: auto;
    font-style: normal;
    font-size: 15px;
    font-weight: 800;
    color: var(--text-color);
    opacity: 0.35;
  }
`;

export const AiSequenceChatBody = styled.div`
  flex: 1;
  overflow: hidden;
  position: relative;
`;

export const AiSequenceChatTrack = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 13px;
  transform: translateY(${({ $offset }) => $offset}px);
  transition: transform 0.55s ease;
`;

export const AiSequenceMsg = styled.div`
  display: ${({ $visible }) => ($visible ? 'flex' : 'none')};
  align-items: flex-end;
  gap: 9px;
  max-width: 84%;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '9px')});
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;
  align-self: ${({ $me }) => ($me ? 'flex-end' : 'flex-start')};
  flex-direction: ${({ $me }) => ($me ? 'row-reverse' : 'row')};
`;

export const AiSequenceAvatar = styled.span`
  width: 28px;
  height: 28px;
  border-radius: 9px;
  flex: none;
  overflow: hidden;
  display: grid;
  place-items: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AiSequenceBubble = styled.div`
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 13.5px;
  line-height: 1.4;
  font-weight: 500;
  color: ${({ $me }) => ($me ? 'var(--white)' : 'var(--text-color-50)')};
  background: ${({ $me }) => ($me ? 'var(--onboarding-brand-gradient)' : 'rgba(255, 255, 255, 0.78)')};
  border: ${({ $me }) => ($me ? '0' : '1px solid rgba(255, 255, 255, 0.6)')};
  border-bottom-left-radius: ${({ $me }) => ($me ? '16px' : '5px')};
  border-bottom-right-radius: ${({ $me }) => ($me ? '5px' : '16px')};
  box-shadow: 0 4px 12px -7px rgba(40, 30, 90, 0.28);
`;

export const AiSequenceCaret = styled.span`
  display: inline-block;
  width: 2px;
  height: 15px;
  vertical-align: -2px;
  margin-left: 1px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 2px;
  animation: aiSeqBlink 1.05s steps(2, jump-none) infinite;

  @keyframes aiSeqBlink {
    50% {
      opacity: 0;
    }
  }
`;

export const AiSequenceTyping = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 10px;

  i {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--text-color);
    opacity: 0.35;
    animation: aiSeqDot 1.25s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.16s;
    }

    &:nth-child(3) {
      animation-delay: 0.32s;
    }
  }

  @keyframes aiSeqDot {
    0%,
    60%,
    100% {
      opacity: 0.3;
      transform: translateY(0);
    }

    30% {
      opacity: 1;
      transform: translateY(-2px);
    }
  }
`;

export const AiSequenceScan = styled.div`
  min-width: 0;
`;

export const AiSequenceScanHead = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  font-weight: 600;
  color: var(--text-color);
  margin-bottom: 8px;

  i {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #2580f3;
  }

  b {
    font-weight: 700;
    color: var(--text-color-50);
  }
`;

export const AiSequenceScanLead = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '5px')});
  transition:
    opacity 0.35s ease,
    transform 0.35s ease;

  span:first-of-type {
    width: 18px;
    height: 18px;
    border-radius: 6px;
    flex: none;
    display: grid;
    place-items: center;
    font-size: 7px;
    font-weight: 700;
    color: var(--white);
    background-image: var(--onboarding-brand-gradient);
  }

  .nm {
    width: 52px;
    flex: none;
    font-size: 8px;
    font-weight: 600;
    color: var(--text-color-50);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bar {
    flex: 1;
    height: 4px;
    border-radius: 3px;
    background: rgba(20, 16, 52, 0.09);
    overflow: hidden;

    i {
      display: block;
      height: 100%;
      width: ${({ $pct }) => $pct}%;
      border-radius: 3px;
      background-image: var(--onboarding-brand-gradient);
      transition: width 0.6s ease;
    }
  }

  .pc {
    width: 24px;
    flex: none;
    text-align: right;
    font-size: 8px;
    font-weight: 700;
    color: #2580f3;
  }
`;

export const AiSequenceFlowStep = styled.div`
  position: absolute;
  width: 74px;
  z-index: 2;
  left: ${({ $left }) => $left};
  top: ${({ $top }) => $top};
  opacity: ${({ $visible, $fading }) => ($fading ? 0 : $visible ? 1 : 0)};
  transform: scale(${({ $visible, $fading }) => ($fading || !$visible ? 0.9 : 1)});
  transition:
    opacity 0.4s ease,
    transform 0.4s ease;
`;

export const AiSequenceFlowNode = styled.div`
  position: relative;
  width: 74px;
  height: 74px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(18px);
  border: 1px solid rgba(255, 255, 255, 0.65);
  display: grid;
  place-items: center;
  box-shadow: ${({ $active, $live }) =>
    $live
      ? 'inset 0 1px 0 rgba(255,255,255,0.9), 0 0 0 1.5px rgba(142,234,0,0.55), 0 12px 30px -16px rgba(50,40,95,0.28)'
      : $active
        ? 'inset 0 1px 0 rgba(255,255,255,0.9), 0 0 0 2px rgba(124,78,240,0.55), 0 12px 30px -16px rgba(50,40,95,0.28)'
        : 'inset 0 1px 0 rgba(255,255,255,0.9), 0 12px 30px -16px rgba(50,40,95,0.28)'};

  .bolt {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    display: grid;
    place-items: center;
    color: var(--white);
    background: ${({ $color }) => $color || 'var(--onboarding-brand-gradient)'};
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);

    svg {
      width: 20px;
      height: 20px;
    }
  }

  .dots {
    position: absolute;
    top: 7px;
    right: 9px;
    font-size: 13px;
    font-weight: 800;
    color: var(--text-color);
    opacity: 0.35;
    line-height: 0.5;
  }
`;

export const AiSequenceFlowBadge = styled.span`
  position: absolute;
  top: -7px;
  right: -7px;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  z-index: 4;
  display: grid;
  place-items: center;
  color: var(--white);
  background: #8eea00;
  box-shadow: 0 0 0 3px rgba(142, 234, 0, 0.22);
  opacity: ${({ $live }) => ($live ? 1 : 0)};
  transform: scale(${({ $live }) => ($live ? 1 : 0.4)});
  transition:
    opacity 0.3s ease,
    transform 0.35s ease;

  svg {
    width: 11px;
    height: 11px;
  }
`;

export const AiSequenceFlowCap = styled.div`
  position: absolute;
  top: ${({ $bottom }) => ($bottom ? 'auto' : '82px')};
  bottom: ${({ $bottom }) => ($bottom ? '84px' : 'auto')};
  left: -36px;
  right: -36px;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-color);
  white-space: nowrap;
`;

export const AiSequenceCfg = styled.div`
  position: absolute;
  left: 664px;
  top: 44px;
  width: 252px;
  z-index: 3;
  padding: 18px 18px 20px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.95),
    0 16px 40px -20px rgba(50, 40, 95, 0.22);
  opacity: ${({ $visible, $fading }) => ($fading ? 0 : $visible ? 1 : 0)};
  transform: translateX(${({ $visible }) => ($visible ? 0 : '16px')});
  transition:
    opacity 0.45s ease,
    transform 0.45s ease;
`;

export const AiSequenceCfgTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-color-50);
  margin-bottom: 14px;

  span {
    color: var(--text-color);
    opacity: 0.4;
    font-size: 16px;
  }
`;

export const AiSequenceCfgTabs = styled.div`
  display: flex;
  gap: 20px;
  border-bottom: 1px solid rgba(20, 16, 52, 0.1);
  margin-bottom: 16px;
`;

export const AiSequenceCfgTab = styled.span`
  font-size: 12.5px;
  font-weight: 600;
  color: ${({ $active }) => ($active ? '#2580f3' : 'var(--text-color)')};
  padding-bottom: 10px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    border-radius: 2px;
    background: #2580f3;
    opacity: ${({ $active }) => ($active ? 1 : 0)};
  }
`;

export const AiSequenceCfgLabel = styled.p`
  margin: 0 0 7px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-color);
`;

export const AiSequenceCfgField = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--white);
  border: 1px solid rgba(20, 16, 52, 0.06);
  border-radius: 11px;
  padding: 10px 12px;
  margin-bottom: 14px;
  box-shadow: 0 2px 6px -3px rgba(40, 30, 90, 0.12);

  .ci {
    width: 24px;
    height: 24px;
    border-radius: 7px;
    flex: none;
    display: grid;
    place-items: center;
    color: var(--white);
    background: ${({ $iconBg }) => $iconBg || 'var(--onboarding-brand-gradient)'};

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .cv {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-color-50);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  svg.chev {
    width: 16px;
    height: 16px;
    color: var(--text-color);
    opacity: 0.4;
    flex: none;
  }
`;

export const AiSequenceLaunchBtn = styled.button`
  width: 100%;
  height: 42px;
  border: 0;
  border-radius: 11px;
  font-size: 14px;
  font-weight: 600;
  color: var(--white);
  cursor: default;
  background: ${({ $live }) =>
    $live ? 'linear-gradient(120deg, #14a05a, #3fbf7a)' : 'var(--onboarding-brand-gradient)'};
  box-shadow: ${({ $live }) =>
    $live ? '0 8px 18px -8px rgba(20,160,90,0.45)' : '0 8px 18px -8px rgba(124,78,240,0.5)'};
  transform: scale(${({ $pressed }) => ($pressed ? 0.96 : 1)});
  transition:
    transform 0.18s ease,
    background 0.35s ease,
    box-shadow 0.3s ease;
`;
